import keyMirror from 'key-mirror'

export default keyMirror({
  SET_LOCALE: null,
  SET_METAMASK: null,
  SET_USER_AUTHENTICATION: null
})